import React from 'react'

import UserList from '../../components/Users/UserList.jsx'
import NavLink from '../../components/Routes/NavLink';
import {user} from '../../core/controllers/user';

export default class UsersTemplate extends React.Component { 
    constructor(props) {
        super(props);
    }

    render(){
        return (
            <div>
                <div class="row">
                    <div class="main-page-header-row col-md-12">
                        <div class="col-md-3 col-sm-6 col-xs-6">
                            <span class="main-page-header-title">Users</span>
                        </div>
                        <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-6">
                            <NavLink to={"/user/new"}>
                                <button type="button" id="add-user" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off">
                                    Add User
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">User Management</h4>
                            <p class="category">Manage and create property manager, contractor, and owner accounts.</p>
                        </div>
                        <UserList />
                    </div>
                </div>
            </div>
            
        )
    }
};


// WEBPACK FOOTER //
// app/views/Users/Users.jsx